import { useNavigate } from "react-router-dom";
import StyledButton from "../../UI/StyledButton";
import StyledInput from "../../UI/StyledInput";
import ReactLoading from "react-loading";
import { useState } from "react";
import CertificatApi from "../../../Api/CertificatApi";
import { directus } from "../../../Api/FetchDirectus";
import { createItem } from "@directus/sdk";
import axios from "axios";
const CertificatForm = ({
  close,
  course,
  certificat_hours,
}: {
  close?: any;
  course: string;
  certificat_hours: string;
}) => {
  const navigate = useNavigate();
  const courseInfo = JSON.parse(localStorage.getItem("courseInfo") || "{}");
  const [lastName, setLastName] = useState("");
  const [firstName, setFirstName] = useState("");
  const [loader, setLoader] = useState(false);
  const [lastNameStatus, setLastNameStatus] = useState(false);
  const [firstNameStatus, setFirstNameStatus] = useState(false);
  const [organizationAccess, setOrganizationAccsess] = useState(false);

  function onChange(e: any, type: string) {
    if (type === "lastName") {
      setLastName(e.target.value);
    }

    if (type === "firstName") {
      setFirstName(e.target.value);
    }
  }

  async function downloadCertificat() {
    setLoader(true);
    if (lastName.trim() === "") {
      setLastNameStatus(true);
    } else {
      setLastNameStatus(false);
    }

    if (firstName.trim() === "") {
      setFirstNameStatus(true);
    } else {
      setFirstNameStatus(false);
    }

    if (!lastNameStatus && !firstNameStatus) {
      let pdfLink: {}[] =
        JSON.parse(localStorage.getItem("certificat_link") || "[]") || [];
      let downloadLink: string = "";

      await CertificatApi.getCertificat({
        name: lastName + " " + firstName,
        email: localStorage.getItem("email") || "",
        course: course,
        certificat_hours: certificat_hours,
      }).then((response) => {
        if (response?.pdfLink) {
          pdfLink = [...pdfLink, { course: course, link: response?.pdfLink }];
          downloadLink = response?.downloadLink || "";
        }
      });

      let certificat_completed =
        JSON.parse(localStorage.getItem("certificat_completed") || "[]") || [];

      certificat_completed.push(courseInfo.id);

      const age = localStorage.getItem("age");
      const gender = localStorage.getItem("gender");
      const activity = localStorage.getItem("activity");
      const position = localStorage.getItem("position");

      try {
        await directus.request(
          createItem("Course_History", {
            email: localStorage.getItem("email"),
            url: "/modules",
            course: localStorage.getItem("courseInfo"),
            module: localStorage.getItem("module_files"),
            topic: localStorage.getItem("topic_files"),
            scales: localStorage.getItem("scales"),
            completed: localStorage.getItem("completed"),
            certificat_completed: certificat_completed,
            certificat_link: pdfLink,
            date: JSON.stringify(new Date()),
            my_courses: localStorage.getItem("my_courses"),
            active_course: localStorage.getItem("active_course"),
            form: JSON.stringify({
              age: age,
              gender: gender,
              activity: activity,
              position: position,
            }),
          })
        );

        localStorage.setItem(
          "certificat_completed",
          JSON.stringify(certificat_completed)
        );
        localStorage.setItem("certificat_link", JSON.stringify(pdfLink));
        setOrganizationAccsess(true);

        const link = document.createElement("a");
        link.href = downloadLink;
        link.setAttribute("download", "certificate.pdf");

        document.body.appendChild(link);
        link.click();
        link.remove();
      } catch (error: any) {
        sessionStorage.removeItem("token");
        navigate("/");
      }
    }

    setLoader(false);
  }

  async function goOrganization() {
    await CertificatApi.sendCertificat();

    close(false);

    navigate("/modules");
  }

  return (
    <div className="popUp">
      <div className="certificatForm">
        <div className="certificatHead">
          <label className="certificatHeadLabel">
            Поздравляем! Вы успешно прошли базовую часть курса
          </label>
          <label>
            Успешное прохождение курса подтверждается электронным
            PDF-сертификатом ЕМИР<br></br>Для формирования электронного
            сертификата укажите свое ФИО
          </label>
        </div>
        <div className="popCertificatForm">
          {lastNameStatus ? (
            <div className="errorText">Фамилия не введена</div>
          ) : null}
          <StyledInput
            text="Фамилия"
            placeholder="Укажите фамилию (будет отражена на сертификате)"
            className={lastNameStatus ? "styledInput error" : "styledInput"}
            onChange={(e: any) => onChange(e, "lastName")}
          />

          {firstNameStatus ? (
            <div className="errorText">Имя не введено</div>
          ) : null}
          <StyledInput
            text="Имя"
            placeholder="Укажите имя (будет отражено на сертификате)"
            className={firstNameStatus ? "styledInput error" : "styledInput"}
            onChange={(e: any) => onChange(e, "firstName")}
          />

          <div className="testFormStartBox">
            {loader ? (
              <ReactLoading
                type="spinningBubbles"
                color="black"
                height={"50px"}
                width={"50px"}
              />
            ) : (
              <StyledButton
                className="blueButton testFormButton"
                text="СКАЧАТЬ СЕРТИФИКАТ"
                onClick={downloadCertificat}
              />
            )}
          </div>
        </div>{" "}
        <div className="certificatHead">
          <label className="certificatHeadLabel">Отлично! А что дальше?</label>
          <label>
            Полученный сертификат даёт право пройти дальнейшее обучение и
            получить <br></br>
            <b>удостоверение о повышении квалификации</b>
          </label>
        </div>
        <div className="popCertificatForm">
          <label>
            Обучение по программе «{courseInfo.title}» производится на базе{" "}
            <b>РУС «ГЦОЛИФК»</b>
          </label>
          <label>
            Формат обучения: <b>онлайн</b> (аналогично базовой части курса)
            <br></br>
            Стоимость: <b>{courseInfo.price} руб.</b>
          </label>
        </div>
        <StyledButton
          className={
            organizationAccess ? "blueButton" : "greyButton disabledButton"
          }
          text={"ПЕРЕЙТИ НА САЙТ ОБРАЗОВАТЕЛЬНОЙ ОРГАНИЗАЦИИ"}
          onClick={organizationAccess ? goOrganization : () => {}}
        />
      </div>
    </div>
  );
};

export default CertificatForm;
